export default function ParseSchedule(idx, dents){
    let bookings = dents[idx].schedule;
    console.log(bookings)
    let newSchedule = [];
    let parsedStart, parsedEnd; 
    let booking;
    for (let i = 0; i < bookings.length; i++){
        let parsedBooking = {};
        booking = bookings[i];

        parsedStart = Date.parse(booking.start)
        parsedEnd = Date.parse(booking.end)
        
        parsedBooking.start = new Date(parsedStart);
        parsedBooking.end = new Date(parsedEnd);

        parsedBooking.id = booking._id;
        parsedBooking.title = booking.title;

        newSchedule.push(parsedBooking);
    }
    return newSchedule;
}